import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useUser } from "../hooks/use-user";

const ProtectedRoute = () => {
  const location = useLocation();
  const { isAuthenticated } = useUser();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
